import React from "react";

import {
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";



function PriorityChart({ data }) {


  const chartData = data.map((item) => ({

    name: item.priority,

    value: item.count,

  }));



  const priorityColors = {

    Critical: "#ef4444",

    High: "#f97316",

    Medium: "#eab308",

    Low: "#22c55e",

  };




  const legendItems = [

    {
      name:"Critical",
      color:"#ef4444"
    },

    {
      name:"High",
      color:"#f97316"
    },

    {
      name:"Medium",
      color:"#eab308"
    },

    {
      name:"Low",
      color:"#22c55e"
    }

  ];





  return (


    <Card

      sx={{
        width:"100%",
        height:"100%",
        minHeight:380,
        display:"flex",

        borderRadius:3,

        background:"#ffffff",

        border:"1px solid #e5e7eb"

      }}

    >



      <CardContent
        sx={{
          p:2.5,
          display:"flex",
          flexDirection:"column",
          flex:1,
        }}
      >


        <Typography

          variant="h6"

          fontWeight={700}

          color="#0f172a"

          mb={2}

        >

          Priority Distribution

        </Typography>





        <Box
          sx={{
            height:250,
            flexShrink:0,
          }}

        >



          <ResponsiveContainer

            width="100%"

            height="100%"

          >



            <BarChart

              data={chartData}

              margin={{

                top:10,

                right:10,

                left:0,

                bottom:10

              }}

            >



              <CartesianGrid

                strokeDasharray="3 3"

              />



              <XAxis

                dataKey="name"

                tick={{
                  fontSize:12
                }}

              />



              <YAxis

                tick={{
                  fontSize:12
                }}

              />



              <Tooltip />




              <Bar

                dataKey="value"

                radius={[8,8,0,0]}

              >


                {

                  chartData.map((item,index)=>(


                    <Cell

                      key={index}

                      fill={
                        priorityColors[item.name]
                      }

                    />


                  ))

                }



              </Bar>




            </BarChart>



          </ResponsiveContainer>



        </Box>





        {/* CUSTOM LEGEND */}


        <Box

          display="flex"

          justifyContent="center"

          gap={2}

          mt={1}

          flexWrap="wrap"

        >


          {

            legendItems.map((item)=>(


              <Box

                key={item.name}

                display="flex"

                alignItems="center"

                gap={0.5}

              >


                <Box

                  sx={{

                    width:10,

                    height:10,

                    borderRadius:"50%",

                    background:item.color

                  }}

                />



                <Typography

                  fontSize={12}

                  color="#64748b"

                >

                  {item.name}

                </Typography>



              </Box>


            ))

          }


        </Box>




      </CardContent>



    </Card>


  );

}



export default PriorityChart;